import { Modal, Row, Col } from "antd";
import Toolbar from "ui/components/Toolbar";
import { useEffect, useState, useCallback } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { Box } from "@chakra-ui/layout";
import SelectContaCategoria from "components/Input/SelectContaCategoria";
import SelectCentroDeCusto from "../../../../../../../../../components/Input/SelectCentroDeCusto/index";
import OutlineButton from "ui/components/Button/OutlineButton";
import DefaultButton from "components/Button/PrimaryButton";

export interface FiltroExecucaoOrcamentariaProps {
  contasCategoriasIds?: string[];
  centrosDeCustoIds?: string[];
}

interface ModalFiltrosExecucaoOrcamentariaProps {
  isOpenModal: boolean;
  onClose: () => any;
  filtro: FiltroExecucaoOrcamentariaProps;
  onChangeFiltro: (v: Partial<FiltroExecucaoOrcamentariaProps>) => void;
}

const defaultFiltro: FiltroExecucaoOrcamentariaProps = {
  contasCategoriasIds: undefined,
  centrosDeCustoIds: undefined,
};

function ModalFiltrosExecucaoOrcamentaria({
  isOpenModal,
  onClose,
  filtro,
  onChangeFiltro,
}: ModalFiltrosExecucaoOrcamentariaProps) {
  const [localFiltro, setLocalFiltro] = useState(filtro);

  const onChangeLocalFiltro = useCallback(
    (_filtro: Partial<FiltroExecucaoOrcamentariaProps>) => {
      setLocalFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  useEffect(() => {
    if (isOpenModal) {
      onChangeLocalFiltro(filtro);
    }
  }, [filtro, isOpenModal, onChangeLocalFiltro]);

  useEffect(() => {
    if (isOpenModal) {
      onChangeLocalFiltro(filtro);
    }
  }, [filtro, isOpenModal, onChangeLocalFiltro]);

  const numeroFiltros =
    (localFiltro?.centrosDeCustoIds?.length ? 1 : 0) +
    (localFiltro?.contasCategoriasIds?.length ? 1 : 0);

  return (
    <Modal
      centered
      visible={isOpenModal}
      footer={
        <Flex flex={1} justifyContent="end" gap={4}>
          <OutlineButton onClick={onClose}>Cancelar</OutlineButton>
          <OutlineButton
            onClick={() => {
              setLocalFiltro(defaultFiltro);
              onChangeFiltro(defaultFiltro);
              onClose();
            }}
          >
            Limpar filtro
          </OutlineButton>
          <DefaultButton
            onClick={() => {
              onChangeFiltro(localFiltro);
              onClose();
            }}
          >
            Filtrar
            {numeroFiltros !== 0 ? `(${numeroFiltros})` : null}
          </DefaultButton>
        </Flex>
      }
      onCancel={onClose}
      destroyOnClose
      width="700px"
      className="antd-custom-header"
      title={<Toolbar title="Filtros" onClose={onClose} border="0px" />}
      closable={false}
    >
      <Flex flexDir="column" width="100%">
        <Box as={Row} mt="16px" gutter={16}>
          <Box as={Col} xs={24}>
            <Text fontSize="13px">Conta categoria</Text>
            <SelectContaCategoria
              multiple
              value={localFiltro.contasCategoriasIds}
              placeholder="Todas as contas categorias"
              onChange={(v) => {
                v.length
                  ? setLocalFiltro((state) => ({
                      ...state,
                      contasCategoriasIds: v,
                    }))
                  : setLocalFiltro((state) => ({
                      ...state,
                      contasCategoriasIds: [],
                    }));
              }}
            />
          </Box>
        </Box>

        <Box as={Row} mt="16px" gutter={16} mb={6}>
          <Box as={Col} md={24} mb={4}>
            <Text mb="2px" fontSize="13px">
              Centro de custo
            </Text>
            <SelectCentroDeCusto
              allowClear
              placeholder="Todos os centros de custo"
              value={localFiltro.centrosDeCustoIds}
              mode="multiple"
              onChange={(v) =>
                v.length
                  ? setLocalFiltro((state) => ({
                      ...state,
                      centrosDeCustoIds: v,
                    }))
                  : setLocalFiltro((state) => ({
                      ...state,
                      centrosDeCustoIds: undefined,
                    }))
              }
            />
          </Box>
        </Box>
      </Flex>
    </Modal>
  );
}

export default ModalFiltrosExecucaoOrcamentaria;
